import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { MdEdit, MdSave, MdClose } from "react-icons/md";

const fields = [
  { label: "Nama Organisasi", name: "school_name", placeholder: "Jogja Madrasah Digital" },
  { label: "Alamat", name: "address", placeholder: "Jl. Sukonandi No.8..." },
  { label: "Instagram", name: "instagram", placeholder: "https://www.instagram.com/..." },
  { label: "YouTube", name: "youtube", placeholder: "https://www.youtube.com/@..." },
  { label: "WhatsApp", name: "whatsapp", placeholder: "628...", hint: "Format internasional tanpa +" },
  { label: "Link Google Maps", name: "link_maps", placeholder: "https://maps.app.goo.gl/..." },
  { label: "Koordinat", name: "coordinates", placeholder: "-7.xxx, 110.xxx" },
];

const ContactSchool = () => {
  const [schoolContact, setSchoolContact] = useState({});
  const [originalProfile, setOriginalProfile] = useState({});
  const [update, setUpdate] = useState(false);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    const fetchSchoolContact = async () => {
      try {
        const response = await axios.get(`/api_w/medsos`, {
          headers: { db_name: process.env.REACT_APP_DB_NAME },
        });
        const profile = response.data.data[0] || {};
        setSchoolContact(profile);
        setOriginalProfile(profile);
      } catch (error) {
        toast.error(error.response?.data?.message || error.message);
      } finally {
        setLoading(false);
      }
    };
    fetchSchoolContact();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSchoolContact((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async () => {
    setSaving(true);
    try {
      await axios.put(`/api_w/medsos/${schoolContact.id}`, schoolContact, {
        headers: {
          Authorization: localStorage.getItem("token"),
          "Content-Type": "application/json",
          db_name: process.env.REACT_APP_DB_NAME,
        },
      });
      toast.success("Berhasil Edit Media Sosial!");
      setOriginalProfile(schoolContact);
      setUpdate(false);
    } catch (error) {
      toast.error("Error Edit Media Sosial: " + (error.response?.data?.message || error.message));
    } finally {
      setSaving(false);
    }
  };

  const handleCancel = () => {
    setSchoolContact(originalProfile);
    setUpdate(false);
  };

  return (
    <div className="mt-5 px-2">
      <div className="mb-6 flex items-center justify-between">
        <div>
          <h2 className="text-2xl font-bold text-navy-700 dark:text-white">Media Sosial & Kontak</h2>
          <p className="text-sm text-gray-500 mt-1">Kelola informasi kontak dan media sosial</p>
        </div>
        {!update && (
          <button onClick={() => setUpdate(true)}
            className="flex items-center gap-2 rounded-xl px-4 py-2 text-sm font-bold text-white shadow-sm"
            style={{ background: "linear-gradient(to right, #16a34a, #15803d)" }}
          >
            <MdEdit className="h-4 w-4" /> Edit
          </button>
        )}
      </div>

      <div className="rounded-2xl bg-white shadow-sm p-6 dark:bg-navy-700">
        {loading ? (
          <div className="py-16 text-center">
            <div className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-brand-500 border-r-transparent" />
          </div>
        ) : (
          <div className="space-y-5">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
              {fields.map((field) => (
                <div key={field.name}>
                  <label className="mb-1.5 block text-sm font-semibold text-navy-700 dark:text-white">{field.label}</label>
                  <input
                    type="text" name={field.name}
                    value={schoolContact[field.name] || ""}
                    onChange={handleChange}
                    readOnly={!update}
                    placeholder={field.placeholder}
                    className={`block w-full rounded-xl border px-4 py-2.5 text-sm outline-none transition-colors ${
                      update
                        ? "border-gray-200 bg-gray-50 text-gray-700 focus:border-brand-500 focus:ring-1 focus:ring-brand-500"
                        : "border-transparent bg-gray-50 text-gray-600 cursor-default"
                    }`}
                  />
                  {field.hint && <p className="mt-1 text-xs text-gray-400">{field.hint}</p>}
                </div>
              ))}
            </div>
            {update && (
              <div className="flex justify-end gap-3 pt-2">
                <button onClick={handleCancel}
                  className="flex items-center gap-2 rounded-xl border border-gray-200 px-6 py-2.5 text-sm font-medium text-gray-600 hover:bg-gray-50 transition-colors"
                >
                  <MdClose className="h-4 w-4" /> Batal
                </button>
                <button onClick={handleSubmit} disabled={saving}
                  className="flex items-center gap-2 rounded-xl px-6 py-2.5 text-sm font-bold text-white shadow-sm disabled:opacity-60"
                  style={{ background: "linear-gradient(to right, #16a34a, #15803d)" }}
                >
                  <MdSave className="h-4 w-4" /> {saving ? "Menyimpan..." : "Simpan"}
                </button>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};
export default ContactSchool;
